var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmsTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2643",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2647"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2657"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2655"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2649",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2653",
    clipPath: "url(#clipPath2657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2659",
    transform: "translate(512,396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -332.03 C 0,-367.3 -28.7,-396 -63.96,-396 h -384.08 c -35.27,0 -63.96,28.7 -63.96,63.97 L -512,0 -256,60 Z",
    style: {
      fill: "#f2f4f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2661"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2663",
    transform: "translate(512,396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -332.03 C 0,-367.3 -28.7,-396 -63.96,-396 H -256 V 60 Z",
    style: {
      fill: "#c2d3ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2665"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2667",
    transform: "translate(512,448.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -52.04 H -512 V 0 c 0,35.271 28.69,63.96 63.96,63.96 H -63.96 C -28.7,63.96 0,35.271 0,0",
    style: {
      fill: "#393c47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2669"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2671",
    transform: "translate(512,448.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -52.04 h -256 v 116 H -63.96 C -28.7,63.96 0,35.271 0,0",
    style: {
      fill: "#232533",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2673"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2675",
    transform: "translate(86.3428,467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -22.017 c -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 H 0 c 8.284,0 15,6.716 15,15 C 15,-6.716 8.284,0 0,0",
    style: {
      fill: "#00ecce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2679",
    transform: "translate(153.3594,467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -22.017 c -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 H 0 c 8.284,0 15,6.716 15,15 C 15,-6.716 8.284,0 0,0",
    style: {
      fill: "#ffe94e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2681"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2683",
    transform: "translate(462.0898,452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.28 -6.72,-15 -15,-15 h -248.74 c -8.28,0 -15,6.72 -15,15 0,8.28 6.72,15 15,15 H -15 C -6.72,15 0,8.28 0,0",
    style: {
      fill: "#b473f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2685"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2687",
    transform: "translate(256,150.0195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -24.8,0 -44.97,20.181 -44.97,44.971 0,24.8 20.17,44.969 44.97,44.969 24.79,0 44.97,-20.169 44.97,-44.969 C 44.97,20.181 24.79,0 0,0 m 146.28,44.971 c 0,22.259 -18.11,40.359 -40.36,40.359 l -8.48,0.011 5.99,5.989 c 7.63,7.62 11.83,17.761 11.83,28.54 0,10.78 -4.2,20.91 -11.83,28.54 -7.62,7.62 -17.75,11.82 -28.54,11.82 -10.78,0 -20.91,-4.2 -28.54,-11.82 l -5.65,-5.66 -0.01,8.141 c 0,22.259 -18.1,40.359 -40.36,40.359 H 0 c -22.1,-0.18 -40.03,-18.209 -40.03,-40.359 v -8.561 l -5.99,6.221 c -0.04,0.029 -0.07,0.059 -0.1,0.09 -15.74,15.74 -41.34,15.74 -57.08,0 -7.62,-7.62 -11.82,-17.75 -11.82,-28.54 0,-10.781 4.2,-20.911 11.8,-28.521 l 6.21,-6.239 -8.91,-0.011 c -22.26,0 -40.36,-18.1 -40.36,-40.359 0,-22.25 18.1,-40.361 40.36,-40.361 h 8.47 l -5.99,-5.99 c -7.62,-7.63 -11.82,-17.76 -11.82,-28.54 0,-10.789 4.2,-20.92 11.82,-28.55 15.74,-15.729 41.35,-15.729 57.08,0 l 6.33,6.33 v -8.809 c 0,-22.141 17.93,-40.181 40.03,-40.361 h 0.33 c 22.26,0 40.36,18.111 40.36,40.361 l 0.01,8.58 5.89,-5.86 c 15.74,-15.741 41.34,-15.73 57.08,0 7.62,7.62 11.82,17.759 11.82,28.54 0,10.78 -4.2,20.919 -11.83,28.549 l -5.77,5.75 h 8.03 c 22.25,0 40.36,18.111 40.36,40.361",
    style: {
      fill: "#00ecce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2689"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2691",
    transform: "translate(361.9199,154.6299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -8.03 l 5.77,-5.75 c 7.63,-7.63 11.83,-17.77 11.83,-28.55 0,-10.78 -4.2,-20.92 -11.82,-28.54 -15.74,-15.729 -41.34,-15.74 -57.08,0 l -5.89,5.861 -0.01,-8.581 c 0,-22.25 -18.1,-40.36 -40.36,-40.36 h -0.33 V -4.61 c 24.79,0 44.97,20.18 44.97,44.97 0,24.8 -20.18,44.97 -44.97,44.97 v 101.31 h 0.33 c 22.26,0 40.36,-18.1 40.36,-40.36 l 0.01,-8.14 5.65,5.66 c 7.63,7.62 17.76,11.82 28.54,11.82 10.79,0 20.92,-4.2 28.54,-11.82 7.63,-7.63 11.83,-17.76 11.83,-28.54 0,-10.78 -4.2,-20.92 -11.83,-28.54 L -8.48,80.73 0,80.72 c 22.25,0 40.36,-18.1 40.36,-40.36 C 40.36,18.11 22.25,0 0,0",
    style: {
      fill: "#00c6cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2693"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2695",
    transform: "translate(462.0898,452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-8.28 -6.72,-15 -15,-15 H -206.09 V 15 H -15 C -6.72,15 0,8.28 0,0",
    style: {
      fill: "#544dc8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2697"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsTools);
export default __webpack_public_path__ + "static/media/cms-tools.8bc118acb71d80b66f6625891b25a866.svg";
export { ForwardRef as ReactComponent };